// Core packages
import { Component, Inject, OnInit } from "@angular/core";

// Third party packages
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";
import { TranslateService } from "@ngx-translate/core";
import { CookieService } from "ngx-cookie-service";

// Custom packages
import { ConfigService } from "src/app/shared/services/config.service";

import moment from 'moment';

/**
 * Script start
 */

@Component({
  selector: "app-print-qrcode-dialog",
  templateUrl: "./print-qrcode-dialog.component.html",
  styleUrls: ["./print-qrcode-dialog.component.scss"]
})
export class PrintQrcodeDialogComponent
  implements OnInit {
  lang = this.translateService.currentLang || this.translateService.defaultLang;

  title = "";
  subtitle = "";
  propertyName = "";

  year: string;

  /**
   * Class constructor
   */
  constructor(
    public dialogRef: MatDialogRef<PrintQrcodeDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public configService: ConfigService,
    private translateService: TranslateService,
    private cookieService: CookieService,
  ) { }

  /**
   * Init components
   *
   * @since 1.0.0
   */
  ngOnInit(): void {
    // Get current lang
    this.lang =
      this.cookieService.get("lang") || this.configService.defaultLang;

    if (this.data.title && this.data.title !== '') {
      this.title = this.data.title;
    } else {
      this.title = this.translateService.instant("companies.dialog.printVideoQrCode.title");
    }

    if (this.data.subtitle && this.data.subtitle !== '') {
      this.subtitle = this.data.subtitle;
    } else {
      this.subtitle = this.translateService.instant("companies.dialog.printVideoQrCode.subtitle");
    }

    if (this.data.propertyName && this.data.propertyName !== '') {
      this.propertyName = this.data.propertyName;
    }

    // Get current year
    this.year = moment().year().toString();
  }

  /**
   * Handle dialog closing
   *
   * @since 1.0.0
   */
  onClose(): void {
    this.dialogRef.close();
  }

  onPrint(): void {
    const printData = document.getElementById('dataToPrint').innerHTML;

    const openWindow = window.open("", "title", "attributes");
    openWindow.document.write(printData);
    openWindow.document.close();
    openWindow.focus();
    openWindow.print();
    openWindow.close();
  }

  
  /**
   * Convert image into Base64
   *
   * @since 1.0.0
   */
   private convertBase64ToBlob(Base64Image: any): Blob {
    // SPLIT INTO TWO PARTS
    const parts = Base64Image.split(';base64,');
    // HOLD THE CONTENT TYPE
    const imageType = parts[0].split(':')[1];
    // DECODE BASE64 STRING
    const decodedData = window.atob(parts[1]);
    // CREATE UNIT8ARRAY OF SIZE SAME AS ROW DATA LENGTH
    const uInt8Array = new Uint8Array(decodedData.length);
    // INSERT ALL CHARACTER CODE INTO UINT8ARRAY
    for (let i = 0; i < decodedData.length; ++i) {
      uInt8Array[i] = decodedData.charCodeAt(i);
    }
    // RETURN BLOB IMAGE AFTER CONVERSION
    return new Blob([uInt8Array], { type: imageType });
  }

  /**
   * Handle save QR code as image
   *
   * @since 1.0.0
   */
   onSaveQRAsImage(parent): void {
    // fetches base 64 date from image
    const parentElement = parent.qrcElement.nativeElement.querySelector("img").src;

    // converts base 64 encoded image to blobData
    const blobData = this.convertBase64ToBlob(parentElement);

    // saves as image
    if (window.navigator && window.navigator.msSaveOrOpenBlob) { //IE
      window.navigator.msSaveOrOpenBlob(blobData, 'Qrcode');
    } else { // chrome
      const blob = new Blob([blobData], { type: "image/png" });
      const url = window.URL.createObjectURL(blob);
      // window.open(url);
      const link = document.createElement('a');
      link.href = url;
      link.download = 'Qrcode.png';
      link.click();
    }
  }

}
